import { Routes, Navigate, Route } from "react-router-dom";
import { isEmpty } from "lodash";

import AdminLayout from "../../layouts/AdminLayout/AdminLayout";
import DashboardAdmin from "../../pages/Admin/DashboardAdmin/DashboardAdmin";
import DashboardAdminContext from "../../context/AdminContext/DashboardAdminContext/DashboardAdminContext";
import NotFoundPage from "./../../pages/Page/NotFoundPage/NotFoundPage";
import ProfileUser from "../../pages/User/ProfileUser/ProfileUser";
import ProfileUserContext from "../../context/UserContext/ProfileUserContext/ProfileUserContext";
import UsersAdmin from "./../../pages/Admin/UsersAdmin/UsersAdmin";
import UserAdminContext from "../../context/AdminContext/UserAdminContext/UserAdminContext";
import LogsAdmin from "../../pages/Admin/LogsAdmin/LogsAdmin";
import LogAdminContext from "../../context/AdminContext/LogAdminContext/LogAdminContext";
import TransactionsUser from "./../../pages/User/TransactionsUser/TransactionsUser";
import TransactionUserContext from "../../context/UserContext/TransactionUserContext/TransactionUserContext";
import ProductsAdmin from "../../pages/Admin/ProductsAdmin/ProductsAdmin";
import ProductAdminContext from "../../context/AdminContext/ProductAdminContext/ProductAdminContext";
import TablesAdmin from "../../pages/Admin/TablesAdmin/TablesAdmin";
import TableAdminContext from "../../context/AdminContext/TableAdminContext/TableAdminContext";
import CueAdmin from "../../pages/Admin/CueAdmin/CueAdmin";
import CueAdminContext from "../../context/AdminContext/CueAdminContext/CueAdminContext";
import OrdersAdmin from "../../pages/Admin/OrdersAdmin/OrdersAdmin";
import OrderAdminContext from "../../context/AdminContext/OrderAdminContext/OrderAdminContext";
import CostsAdmin from "../../pages/Admin/CostsAdmin/CostsAdmin";
import CostAdminContext from "../../context/AdminContext/CostAdminContext/CostAdminContext";
import SettingAdmin from "../../pages/Admin/SettingAdmin/SettingAdmin";
import SettingAdminContext from "../../context/AdminContext/SettingAdminContext/SettingAdminContext";
import DebtorsAdmin from "../../pages/Admin/DebtorsAdmin/DebtorsAdmin";
import DebtorAdminContext from "../../context/AdminContext/DebtorAdminContext/DebtorAdminContext";
import { decodeJWT, getCookies } from "../../utils";
import { userRoleItems } from "../../utils/enum";

const AdminContainer = () => {
  const accessToken = getCookies("accessToken");

  const isLogin = !isEmpty(accessToken);

  const roleName = decodeJWT(accessToken)?.role;

  if (!isLogin || roleName !== userRoleItems[0])
    return <Navigate to="/" replace />;

  return (
    <AdminLayout>
      <Routes>
        {/* Dashboard */}
        <Route
          index
          element={
            <DashboardAdminContext>
              <DashboardAdmin />
            </DashboardAdminContext>
          }
        />

        {/* Logs */}
        {["/logs", "/logs/:user/user"].map((path) => (
          <Route
            key={path}
            path={path}
            element={
              <LogAdminContext>
                <LogsAdmin />
              </LogAdminContext>
            }
          />
        ))}

        {/* Profile */}
        <Route
          path="/profile"
          element={
            <ProfileUserContext>
              <ProfileUser />
            </ProfileUserContext>
          }
        />

        {/* Admins */}
        <Route
          path="/admins"
          element={
            <UserAdminContext role={userRoleItems[0]}>
              <UsersAdmin />
            </UserAdminContext>
          }
        />
        {/* Customers */}
        <Route
          path="/customers"
          element={
            <UserAdminContext role={userRoleItems[1]}>
              <UsersAdmin />
            </UserAdminContext>
          }
        />
        {/* Products */}
        <Route
          path="/products"
          element={
            <ProductAdminContext>
              <ProductsAdmin />
            </ProductAdminContext>
          }
        />
        {/* Tables */}
        <Route
          path="/tables"
          element={
            <TableAdminContext>
              <TablesAdmin />
            </TableAdminContext>
          }
        />
        {/* Cue */}
        <Route
          path="/cue"
          element={
            <CueAdminContext>
              <CueAdmin />
            </CueAdminContext>
          }
        />
        {/* Setting */}
        <Route
          path="/setting"
          element={
            <SettingAdminContext>
              <SettingAdmin />
            </SettingAdminContext>
          }
        />
        {/* Costs */}
        <Route
          path="/costs"
          element={
            <CostAdminContext>
              <CostsAdmin />
            </CostAdminContext>
          }
        />
        {/* Debtors */}
        <Route
          path="/debtors"
          element={
            <DebtorAdminContext>
              <DebtorsAdmin />
            </DebtorAdminContext>
          }
        />
        {/* Transactions */}
        {["/transactions", "/transactions/:user/user"].map((path) => (
          <Route
            key={path}
            path={path}
            element={
              <TransactionUserContext>
                <TransactionsUser />
              </TransactionUserContext>
            }
          />
        ))}
        {/* Orders */}
        {[
          "/orders",
          "/accounting",
          "/accounting/:user/user",
          "/orders/:user/user",
        ].map((path) => (
          <Route
            key={path}
            path={path}
            element={
              <OrderAdminContext>
                <OrdersAdmin />
              </OrderAdminContext>
            }
          />
        ))}

        {/* Not Found */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </AdminLayout>
  );
};

export default AdminContainer;
